import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { State } from '../../types/StateType'
import { AdmissionType } from './types'

const patientAdmissionsAdapter = createEntityAdapter<AdmissionType>({
  selectId: (admissionData) => admissionData.admissionKey,
})

let definedProps: { error: any; loading: boolean; success: any } = {
  error: null,
  loading: false,
  success: null,
}

const initialState = patientAdmissionsAdapter.getInitialState(definedProps)

const patientAdmissionsSlice = createSlice({
  name: 'patientAdmissions',
  initialState: initialState,
  reducers: {
    getPatientAdmissions: (state) => {
      state.loading = true
    },
    addPatientAdmissions: (state, action: PayloadAction<AdmissionType[]>) => {
      state.loading = false
      patientAdmissionsAdapter.removeAll(state)
      patientAdmissionsAdapter.upsertMany(state, action.payload)
    },
    errorPatientAdmissions: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    successPatientAdmissions: (state, action: PayloadAction<string | null>) => {
      state.success = action.payload
    },
  },
})

export const {
  addPatientAdmissions,
  getPatientAdmissions,
  errorPatientAdmissions,
  successPatientAdmissions,
} = patientAdmissionsSlice.actions

export default patientAdmissionsSlice.reducer

const { selectById } = patientAdmissionsAdapter.getSelectors()

export const selectAllPatientAdmissions = createSelector(
  (state: State) => state.patientAdmissionDataState,
  (patientAdmissions) => Object.values(patientAdmissions['entities'])
)

export const selectPatientAdmissionsById = (id: string) =>
  createSelector(
    (state: State) => state.patientAdmissionDataState,
    (patientAdmissions) => selectById(patientAdmissions, id)
  )

export const selectErrorInPatientAdmissions = createSelector(
  (state: State) => state.patientAdmissionDataState.error,
  (error) => error
)
export const selectSuccessInPatientAdmissions = createSelector(
  (state: State) => state.patientAdmissionDataState.success,
  (success) => success
)
export const selectPatientAdmissionLoadingState  = createSelector(
  (state: State) => state.patientAdmissionDataState.loading,
  (success) => success
)
